module.exports = __webpack_public_path__ + "img/amigo.a9fa4e7e.png";